import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import type { NotificationCategory } from '../../../types/personPreferenceNotificationSettings';
import { updateNotificationSettings, fetchNotificationSettings } from '../../../services/notificationSettings';
import { getCsrfToken } from '../../../libs/csrfToken';

type Props = { personId: number; };

export const Component: FunctionComponent<Props> = ({ personId }) => {

  const [notificationCategories, setNotificationCategories] = useState<NotificationCategory[]>([]);
  const [updatingNotificationIds, setUpdatingNotificationIds] = useState<number[]>([]);

  useEffect(() => {
    handleFetchNotificationSettings();
  }, []);

  const handleFetchNotificationSettings = async () => {
    const response = await fetchNotificationSettings(personId);
    setNotificationCategories(response.notification_categories);
  };

  const onToggleChange = async (notificationId: number, enabled: boolean) => {
    if (updatingNotificationIds.includes(notificationId)) return;

    setUpdatingNotificationIds((prev) => [...prev, notificationId]);
    try {
      const response = await updateNotificationSettings(personId, notificationId, enabled, getCsrfToken());
      if (response.status === 'success') {
        setNotificationCategories((prev) => prev.map((category) => ({
          ...category,
          notifications: category.notifications.map((notification) => (
            notification.id === notificationId ? { ...notification, enabled } : notification
          )),
        })));
      }
    } finally {
      setUpdatingNotificationIds((prev) => prev.filter((id) => id !== notificationId));
    }
  };

  return (
    <Presentation
      notificationCategories={notificationCategories}
      updatingNotificationIds={updatingNotificationIds}
      onToggleChange={onToggleChange}
    />
  );
};
